export const ADD_TO_CART = "ADD_TO_CART";
export const ADD_TO_WISHLIST = "ADD_TO_WISHLIST";
export const ADJUST_ITEM_QTY = "ADJUST_ITEM_QTY";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const LOAD_CURRENT_ITEM = "LOAD_CURRENT_ITEM";
export const SET_PRODUCTS = "SET_PRODUCTS";
export const SELECTED_PRODUCTS = "SELECTED_PRODUCTS";
export const SET_CART = "SET_CART";
